import React from 'react';
import './css/SideBar.css';
import { withStyles } from '@material-ui/core/styles';
import FilterCollection from './FilterCollection';
import RangeSlider from './RangeSlider';
import InformationBox from './InformationBox';
import TransitionSwitch from './TransitionSwitch';
import DownloadButton from './DownloadButton';
import SideBox from './SideBox';

const styles = {
  paper: {
    // background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
    background: '#3182bd',
    alignItems: 'center',
  },
  hide: {
    display: 'none',
  },
};

class SideBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      province: "Select",
      data: []
    }
  }

  componentDidUpdate(prevProps) {
    const dataLoaded = prevProps.data !== this.props.data;
    const provChanged = prevProps.provinces !== this.props.provinces;

    if (dataLoaded || provChanged) {
      let uncrpdProvArticles = [];

      if (this.props.provinces.length) {
        let articles;
        for (let i = 0; i < this.props.provinces.length; i++) {
          //change below in future, throws warning
          articles = this.props.data.filter(element => { 
            return element.name === this.props.provinces[i]; 
          });
          uncrpdProvArticles.push(articles[0]);
        }
      } else { 
        uncrpdProvArticles = [];
      }

      this.setState(() => {
        return {
          province: this.props.provinces,
          data: uncrpdProvArticles
        }
      });
    }
  }

  render() {
    return (
      <div>
        <SideBox title="DOWNLOADS">
          <DownloadButton />
        </SideBox>
        <SideBox title="FILTERS">
          <FilterCollection
            onUnitChange={this.props.onUnitChange}
            onTypeChange={this.props.onTypeChange}
          />
          <RangeSlider
            min={this.props.minYear}
            max={this.props.maxYear}
            onSliderChange={this.props.onSliderChange}
          />
          <TransitionSwitch 
            onTransitionChange={this.props.onTransitionChange}
          />
        </SideBox>
        <SideBox title="INFORMATION">
          <InformationBox
            provinces={this.props.provinces}
            title={this.props.program}
            data={this.state.data}
            program={this.props.programData}
          />
        </SideBox>
      </div>
    );
  }
};

export default withStyles(styles)(SideBar);